import React from 'react';
import styled, { css } from 'styled-components';

import { ContentContainer } from '@/modules/JacHome/common.styles';
import { useJacHomeData } from '@/modules/JacHome/hooks';
import { ServiceFormSecondary } from '@/components/LandingWidgets';
import { media } from '@/utils/mixin';
import { ServiceFormSecondaryFields } from '@/components/LandingWidgets/components/ServiceFormSecondary/types';
import { submitJacTestDriveForm } from '@/services/leads/leads-service';
import { googleEvent } from '@/utils/events';
import { getDealersOptions } from '@/utils/common';

function TestDriveForm() {
  const {
    formTitle,
    formSubtitle,
    formImage,
    formMobileImage,
    formButtonTitle,
    formGoogleEvent,
    dealersRequests,
  } = useJacHomeData();

  if (!formTitle || !formImage) {
    return null;
  }

  const sendTestDriveForm = async (
    values: ServiceFormSecondaryFields
  ): Promise<void> => {
    try {
      await submitJacTestDriveForm({
        ...values,
        dealer: values.dealer?.value,
      }).then(() => {
        if (formGoogleEvent) {
          googleEvent(formGoogleEvent);
        }
      });
    } catch (error: any) {
      return Promise.reject(error);
    }
  };

  return (
    <Component id="test-drive">
      <ContentContainer>
        <ServiceFormSecondary
          title={formTitle}
          subtitle={formSubtitle ?? ''}
          image={formImage}
          buttonTitle={formButtonTitle ?? ''}
          imageMobile={formMobileImage}
          fieldsConfig={{ dealers: getDealersOptions(dealersRequests) }}
          onSubmit={sendTestDriveForm}
        />
      </ContentContainer>
    </Component>
  );
}

export default TestDriveForm;

const Component = styled.section`
  padding: 30px 0;

  ${media.tablet(css`
    padding: 20px 0;
  `)}
`;
